import React from 'react';

const CalendarHeaderDates = ({
  calendarDates, datesRangeSelected, colSpan = 1,
  onClickDate, onMouseOverDate, onMouseOutDate,
}) => {
  const selectedDates = datesRangeSelected.slice().sort((a, b) => a.localeCompare(b));
  return (
    <tr className="row-price-header">
      {
        calendarDates.map((calendarDate, i) => {
          const [day, numDate] = (calendarDate.label || '').split(' ');
          const date = calendarDate.stringISO;
          let className = 'cell-day';
          if (date === selectedDates[0] || date === selectedDates[1]) {
            className += ' selected';
          } else if (selectedDates.length === 2 && date > selectedDates[0] && date < selectedDates[1]) {
            className += ' selected';
          }
          return (
            <td
              key={ i }
              colSpan={ colSpan }
              className={ className }
              onClick={ onClickDate.bind(null, date) }
              onMouseOver={ onMouseOverDate.bind(null, date) }
              onMouseOut={ onMouseOutDate.bind(null, date) } >
                <div>{ day }<br/>{ numDate }</div>
            </td>
          );
        })
      }
    </tr>
  );
};

export default CalendarHeaderDates;



// WEBPACK FOOTER //
// ../hyperdb-utils/src/components/CalendarHeaderDates.jsx